import type { UpdateLeadRequest } from '@witmetrics/api-client';
import { isNullish } from '@witmetrics/utils/misc';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[1000px] min-w-[500px]',
  input: 'w-full py-3',
  section: 'w-full max-w-[500px]',
  textField: 'w-full',
  selectDropdown: 'w-full',
  body: 'pt-0 pb-6 w-full min-h-0 max-h-[450px] h-[70vh] overflow-auto',
};

export function updatePatient(
  patientId: number,
  createdAt: string | null,
  data: UpdateLeadRequest
) {
  const updates: UpdateLeadRequest = { ...data };
  if (!isNullish(createdAt)) updates.createdAt = createdAt;
  return API.Leads.updateLead(patientId, updates);
}
